export default __webpack_public_path__ + "src/assets/membership.d088114680f6e007f7faee42cd7c05bf.svg";